import { styled, css, breakpoint } from '../styled-components'

export const HeadlineCSS = css`
  font-family: ${props => props.theme.headlineFont};
  font-weight: ${props => props.theme.headlineWeight};
  color: ${props => props.theme.headlineColor};
  font-size: 20px;
  margin-bottom: 10px;
  ${breakpoint('tablet')`
    font-size: 30px;
  `}
`

export const Headline = styled.h1<{ centered?: boolean }>`
  ${HeadlineCSS};
  ${props => props.centered && `text-align: center;`};
`

export const SubHeadline = styled.h3<{ centered?: boolean, primary?: boolean }>`
  font-family: ${props => props.theme.headlineFont};
  font-weight: ${props => props.theme.subHeadlineWeight};
  ${props => props.centered && `text-align: center;`};
  ${props => props.primary && `color: ${props.theme.primaryColor}`};
  font-size: 13px;
  ${breakpoint('tablet')`
    font-size: 18px;
  `}
`
